import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appRestrictNumbers]',
  standalone: false
})
export class RestrictNumbersDirective {

  private numberPattern = /[0-9]/g; // Match numbers

  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: InputEvent): void {
    const input = this._el.nativeElement as HTMLInputElement;
    const cleanedValue = input.value.replace(this.numberPattern, ''); // Remove numbers
    if (input.value !== cleanedValue) {
      input.value = cleanedValue; // Set cleaned value
      event.stopImmediatePropagation(); // Prevent propagation
    }
  }

}
